import "./App.css";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useHistory,
} from "react-router-dom";
import Home from "./Home/Home";
import NewArticleCont from "./Admin/NewArticle/NewArticleCont";
import AdminContextProvider from "./Context/AdminContext";
import DBContextProvider from "./Context/DBcontext";
import StorageContextProvider from "./Context/StorageContext";
import React, { useEffect } from 'react';
import ArticleDetailCont from "./Articles/ArticleDetailCont";
import ArticleSectionCont from "./Articles/ArticleSectionCont";
import Dashboard from "./Admin/Dashboard/Dashboard";
import Drafts from "./Admin/Articles/Drafts";
import Articles from "./Admin/Articles/Articles";
import Gallery from "./Admin/Gallery/Gallery";
import EditArticleCont from "./Admin/Articles/EditArticleCont";
import Login from "./Login/Login";
import UsersContextProvider from "./Context/UsersContext";
import BannersEdit from "./Admin/Banners/BannersEdit";

function App() {
  useEffect(() => {
    window.fbAsyncInit = function() {
      window.FB.init({
        appId      : 'TU_APP_ID',
        cookie     : true,
        xfbml      : true,
        version    : 'v17.0' // Usa la versión más reciente de la API
      });
      window.FB.AppEvents.logPageView();
    };

    // Carga el SDK de Facebook de forma asíncrona
    (function(d, s, id){
      var js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {return;}
      js = d.createElement(s); js.id = id;
      js.src = "https://connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  }, []);

  return (
    <BrowserRouter>
      <AdminContextProvider>
      <DBContextProvider>
      <StorageContextProvider>
      <UsersContextProvider>
        <div>
          <Routes>
          <Route path="/*" element={<Home />} />
            <Route path="/" element={<Home />} />
            <Route path="/article/:id" element={<ArticleDetailCont />} />
            <Route path="/articulos/:id" element={<ArticleSectionCont />} />
            <Route path="/adm/create" element={<NewArticleCont />} />
            <Route path="/adm/edit/:id" element={<EditArticleCont />} />
            <Route path="/adm" element={<Articles />} />
            <Route path="/adm/banners" element={<BannersEdit />} />
            {/* <Route path="/adm/drafts" element={<Drafts />} /> */}
            <Route path="/adm/gallery" element={<Gallery />} />
            {/* <Route path="/adm" element={<Dashboard />} /> */}
            <Route path="/adm/login" element={<Login />} />
          </Routes>
        </div>
        </UsersContextProvider>
        </StorageContextProvider>
        </DBContextProvider>
      </AdminContextProvider>

    </BrowserRouter>
  );
}

export default App;
